<template>
  <div class="main clearfix">
    <div class="footer-nav fl clearfix">
      <!-- <ul class="footer-nav-item fl">
        <li><a href="#">网站首页</a></li>
        <li><a href="#">走进我家</a></li>
        <li><a href="#">联系我们</a></li>
      </ul>
      <ul class="footer-nav-item fl">
        <li><a href="#">我家优势</a></li>
        <li><a href="#">电商平台</a></li>
        <li><a href="#">运营模式</a></li>
      </ul>
      <ul class="footer-nav-item fl">
        <li><a href="#">物流经纪</a></li>
        <li><a href="#">我家车务</a></li>
      </ul> -->
    </div>
    <div class="footer-other fr clearfix" style="width: 33%">
      <el-row>
        <el-col :span="6">
          <img :src="GLOBAL.UI.we_chat_code" style="width: 100%" />
        </el-col>
        <el-col :span="18">
          <ul class="">
            <li>地址：{{ GLOBAL.UI.address }}</li>
            <li>电话：{{ GLOBAL.UI.phone }}</li>
            <li>邮编：{{ GLOBAL.UI.zip_code }}</li>
            <li>邮箱：{{ GLOBAL.UI.email }}</li>
          </ul>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped lang="scss">
.footer-nav li {
  margin-bottom: 10px;
}
.footer-nav-item {
  margin-right: 100px;
}
.footer-other img {
  float: left;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/master-bottom.vue